module.exports = __webpack_public_path__ + "static/media/img_intgration_partner_02.b7caaec1.png";